declare namespace $ {

	export class $mol_icon_all_inclusive extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=inclusive.view.tree.d.ts.map